import { Controller } from '@hotwired/stimulus';
import { useEventListener } from 'stimulus-library';
import Cookies from 'js-cookie';

export default class extends Controller {
  get currency() {
    return Cookies.get('currency') || 'USD';
  }

  connect() {
    const selectedCurrency = this.currency;
    Array.from(this.element.options).find((option) => option.value === selectedCurrency).selected = true;
    useEventListener(this, this.element, 'change', this.change);
  }

  change(event) {
    Cookies.set('currency', event.target.value);
    window.location.reload();
  }
}
